<template>
  <div class="breadcrumbs">
    <ul itemtype="http://schema.org/BreadcrumbList" itemscope="1">
      <li
        itemtype="http://schema.org/ListItem"
        itemscope="1"
        itemprop="itemListElement"
      >
        <a itemprop="item" href="/" :title="getHomepageUrl()">
          <span itemprop="name">{{ getHomepageUrl() }}</span>
        </a>
        <meta content="1" itemprop="position" />
      </li>
      <template v-if="getBreadcrumbs()">
        <li
          itemtype="http://schema.org/ListItem"
          itemscope="1"
          itemprop="itemListElement"
          v-for="(crumb, idx) in getBreadcrumbs()"
          :key="idx"
        >
          <template v-if="crumb.url != ''">
            <a
              itemprop="item"
              :href="crumb.url"
              :title="getCrumbHead(crumb, idx)"
            >
              <span itemprop="name">{{ getCrumbHead(crumb, idx) }}</span>
            </a>
          </template>
          <template v-else>
            <span itemprop="item">
              <span itemprop="name" :class="getCrumbClass(crumb)">{{
                crumb.name
              }}</span>
            </span>
          </template>
          <meta :content="idx + 2" itemprop="position" />
        </li>
      </template>
      <li
        itemtype="http://schema.org/ListItem"
        itemscope="1"
        itemprop="itemListElement"
      >
        <span itemprop="item">
          <span itemprop="name" class="font-m gray-60">{{ getHotel() }}</span>
        </span>
        <meta :content="getBreadSize()" itemprop="position" />
      </li>
    </ul>
  </div>
</template>

<script>
import * as CONFIG from ".././config.js";
import * as GEOSTRUCTURE from "../../../geotree.js";
import axios from "axios";

axios.defaults.withCredentials = false;

export default {
  props: {
    locid: String,
    hotel: String
  },
  data: () => ({
    url: "/getladneurle.json",
    breadcrumbs: []
  }),
  methods: {
    getHotel() {
      return this.hotel;
    },
    getBreadSize() {
      return this.breadcrumbs.length + 2;
    },
    getCrumbClass(crumb) {
      if (crumb.bold && crumb.bold == "1") {
        return "font-m";
      } else {
        return "font-r";
      }
    },
    getCrumbHead(crumb, idx) {
      if (idx == 0) {
        return "Lista ofert";
      } else {
        return crumb.name;
      }
    },
    getHomepageUrl() {
      let serviceName = CONFIG.serwis;
      return serviceName.charAt(0).toUpperCase() + serviceName.slice(1);
    },
    getBreadcrumbs() {
      return this.breadcrumbs;
    },
    getLadneUrle() {
      var pars = "locid=" + this.locid + "&x=1";
      return axios
        .get(CONFIG.API_URL + this.url + "?" + pars, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json"
          }
        })
        .then(response => {
          /*alert("DATA:" + response.data);
               alert("STATUS:" + response.status);
               alert("DATA ITEMS:" + JSON.stringify(response.data));*/
          return response.data;
        })
        .catch(e => {
          alert("ERROR" + e);
        });
    }
  },
  mounted() {
    let locid = this.locid;
    let that = this;
    this.getLadneUrle().then(data => {
      //alert('ITEMS:' + JSON.stringify(data));
      if (
        data != null &&
        data.MainPage &&
        data.MainPage.page &&
        data.MainPage.page.BreadcrumbsURL &&
        data.MainPage.page.BreadcrumbsURL[0]
      ) {
        that.breadcrumbs = data.MainPage.page.BreadcrumbsURL[0];
      }
    });
  },
  updated() {
    let that = this;
    this.$nextTick(function() {
      if (this.getBreadcrumbs().length && this.getHotel() != "") {
        that.$root.$emit("update:hotelBreadcrumbsReady", true);
      }
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@/components/T1Breadcrumbs/T1BreadcrumbsStyles";
</style>
